import { ENDPOINTS } from 'shared/constants/ENDPOINTS';
import { useAxios } from 'shared/hooks/useAxios';
import { IChannelRequestPayload, IChannelResponsePayload } from 'shared/interfaces/IChannel';
import { transformPayload } from 'shared/utils/transformPayload';

export const useChannelDao = () => {
  const { GET } = useAxios();

  const getChannel = async (payload?: IChannelRequestPayload) => {
    const transformedPayload = transformPayload<IChannelRequestPayload>(payload);

    const response = await GET<IChannelResponsePayload>({
      url: ENDPOINTS.CHANNEL,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  // FOR FILTER SEARCH AND CREATE NEW CHANNEL
  const getChannelSearch = async (payload?: IChannelRequestPayload) => {
    const transformedPayload = transformPayload<IChannelRequestPayload>(payload);

    const response = await GET<IChannelResponsePayload>({
      url: ENDPOINTS.CHANNEL,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  const getSingleChannel = async (id?: string) => {
    const transformedPayload = transformPayload({ _id: id, limit: 1 });

    const response = await GET<IChannelResponsePayload>({
      url: `${ENDPOINTS.CHANNEL}/show`,
      params: {
        token: transformedPayload,
      },
    });

    return response.data;
  };

  return {
    getChannel,
    getSingleChannel,
    //
    getChannelSearch,
  };
};
